import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { CreateAccountComponent as SharedCreateAccountComponent, FormStepSingleRouteService, AjaxHandlerService, CountriesService, TranslationService, BrandService, RegistrationProvidersService } from '@whitehatgaming/shared';
import { ActivatedRoute, Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss']
})
export class CreateAccountComponent extends SharedCreateAccountComponent implements OnInit {

  get language(): string {
    return this.translation.language;
  }
  country: string;
  bonusAmount: string;
  upToAmount: string;
  showPromotions: boolean;
  showPromotionsPanel: boolean = false;

  constructor(
    formStepSingleRoute: FormStepSingleRouteService,
    activatedRoute: ActivatedRoute,
    router: Router,
    ajaxHandler: AjaxHandlerService,
    cookieService: CookieService,
    brand: BrandService,
    private countries: CountriesService,
    private translation: TranslationService,
    registrationProviders: RegistrationProvidersService,
  ) {

    super(formStepSingleRoute, activatedRoute, router, ajaxHandler, cookieService, brand, registrationProviders);

    this.countries.getCountry().subscribe((data) => {

      this.country = data.value.toLowerCase();

      if(this.country != 'se'){
        if(this.country == "gb"){
          this.bonusAmount = "200%";
          this.upToAmount = "£500";
        }

        if(this.country != "gb" && this.country != "fi"){
          this.bonusAmount = "200%";
          this.upToAmount = "€5000";

          if(this.country == "no"){
            this.upToAmount = "5000kr";
          }
        }

        // Finland
        if(this.country == "fi"){

          this.bonusAmount = "100%";
          this.upToAmount = "5000kr";
        }

        // Canada
        if(this.country == "ca"){

          this.bonusAmount = "200%";
          this.upToAmount = "$5000";
        }

        this.showPromotions = true;
      }
    })
   }

  ngOnInit() {
  }

}
